import React from 'react';

// Electric pulse animation component - creates flowing energy effect
const ElectricPulse = () => {
  return (
    <div className="electric-container">
      {/* SVG Electric Lines */}
      <svg className="electric-svg" viewBox="0 0 1920 1080" preserveAspectRatio="none">
        <defs>
          {/* Glow filter */}
          <filter id="glow">
            <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
            <feMerge>
              <feMergeNode in="coloredBlur"/>
              <feMergeNode in="SourceGraphic"/>
            </feMerge>
          </filter>
          
          {/* Animated gradient */}
          <linearGradient id="electricGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="transparent">
              <animate attributeName="offset" values="0;1" dur="2s" repeatCount="indefinite"/>
            </stop>
            <stop offset="20%" stopColor="#d4c19c">
              <animate attributeName="offset" values="0.2;1.2" dur="2s" repeatCount="indefinite"/>
            </stop>
            <stop offset="40%" stopColor="transparent">
              <animate attributeName="offset" values="0.4;1.4" dur="2s" repeatCount="indefinite"/>
            </stop>
          </linearGradient>

          <linearGradient id="electricGradient2" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="transparent">
              <animate attributeName="offset" values="0;1" dur="3s" repeatCount="indefinite"/>
            </stop>
            <stop offset="15%" stopColor="#9c7c5e">
              <animate attributeName="offset" values="0.15;1.15" dur="3s" repeatCount="indefinite"/>
            </stop>
            <stop offset="30%" stopColor="transparent">
              <animate attributeName="offset" values="0.3;1.3" dur="3s" repeatCount="indefinite"/>
            </stop>
          </linearGradient>
        </defs>

        {/* Electric path 1 - top flowing line */}
        <path
          d="M-100,200 Q200,180 400,220 T800,180 T1200,240 T1600,160 T2000,200"
          fill="none"
          stroke="url(#electricGradient)"
          strokeWidth="2"
          filter="url(#glow)"
          opacity="0.5"
        />

        {/* Electric path 2 - middle flowing line */}
        <path
          d="M-100,540 Q300,500 600,560 T1000,520 T1400,580 T1800,500 T2100,540"
          fill="none"
          stroke="url(#electricGradient2)"
          strokeWidth="1.5"
          filter="url(#glow)"
          opacity="0.35"
        />

        {/* Electric path 3 - bottom flowing line */}
        <path
          d="M-100,880 Q250,860 500,900 T900,850 T1300,920 T1700,840 T2000,880"
          fill="none"
          stroke="url(#electricGradient)"
          strokeWidth="2"
          filter="url(#glow)"
          opacity="0.4"
        />
      </svg>

      {/* Floating particles */}
      <div className="particles">
        {[...Array(8)].map((_, i) => (
          <div 
            key={i} 
            className="particle"
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${5 + Math.random() * 4}s`
            }}
          />
        ))}
      </div>

      <style>{`
        .electric-container {
          position: absolute;
          inset: 0;
          overflow: hidden;
          pointer-events: none;
        }

        .electric-svg {
          position: absolute;
          width: 100%;
          height: 100%;
          opacity: 0.7;
        }

        .particles {
          position: absolute;
          inset: 0;
        }

        .particle {
          position: absolute;
          width: 3px;
          height: 3px;
          background: #d4c19c;
          border-radius: 50%;
          box-shadow: 0 0 8px #d4c19c, 0 0 16px #d4c19c;
          animation: float-up linear infinite;
          opacity: 0;
        }

        @keyframes float-up {
          0% {
            transform: translateY(100vh) scale(0);
            opacity: 0;
          }
          10% {
            opacity: 0.6;
          }
          90% {
            opacity: 0.6;
          }
          100% {
            transform: translateY(-20vh) scale(1);
            opacity: 0;
          }
        }
      `}</style>
    </div>
  );
};

export default ElectricPulse;
